import hindi from "../images/language/hn-lang.svg";
import eng from "../images/language/en-lang.svg";
import banner1 from "../images/banner/Banner_1.png";
import banner2 from "../images/banner/Banner_20.png";
import linkImg1 from "../images/home-slider/1.jpg";
import linkImg2 from "../images/home-slider/2.png";
import linkImg3 from "../images/home-slider/3.png";
import linkImg4 from "../images/home-slider/4.png";
import linkImg6 from "../images/home-slider/6.png";
import linkImg7 from "../images/home-slider/7.png";
import img1Abt from "../images/about/newYogi.png";
import img2Abt from "../images/about/dummy.png";
import img3Abt from "../images/about/dummy.png";
import img4Abt from "../images/about/dummy.png";
import img5Abt from "../images/about/dummy.png";

export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const GOOGLE_CX_CODE = process.env.REACT_APP_API_GOOGLE_CX_CODE; // TO ENABLE GOOGLE SITE INDEXING AND IN-SITE GOOGLE SEARCH

// export const BASE_URL = "http://192.168.23.13:3001/api/"; //? Abhishek

// export const BASE_URL = "http://192.168.23.25:3000/api/"; //? Shweta
// export const BASE_URL_IMG = "http://192.168.23.25:3000/"; //? Shweta

// export const  BASE_URL ="http://192.168.23.177:3001/api/"; //? Varun
// export const BASE_URL_IMG ="http://192.168.23.35:3002/"; //? Shweta

export const BASE_URL_IMG = 'https://upsosb.demoquaeretech.in/api/'//process.env.REACT_APP_API_BASE_URL_IMG; //!Image BASE URL Prod
export const BASE_URL_IMG_LMS = process.env.REACT_APP_API_BASE_URL_IMG_LMS; //!Image BASE URL Prod
export const BASE_URL_AI = process.env.REACT_APP_API_BASE_URL_AI; //!AI URL Prod

export const BASE_URL = () => {
  const type = localStorage?.getItem("type");
  if (type == "admin") {
    return  "https://upsosb.demoquaeretech.in/api/api/"//process.env.REACT_APP_API_BASE_URL; //! Prod
  } else if (type == "lms_admin") {
    return  process.env.REACT_APP_API_BASE_URL_LMS; //! Prod
  }
};

export const navBarData = [
  {
    label: "Home",
    url: "/",
  },
  {
    label: "About Us",
    submenu: [
      {
        label: "Profile",
        url: "/pages/profile",
        submenu: [
          {
            label: "Profile Sub",
            url: "/pages/profile-sub",
            submenu: [
              {
                label: "Profile sub sub",
                url: "/pages/profile-sub-sub",
              },
            ],
          },
        ],
      },
      {
        label: "Chairman Message",
        url: "/pages/chairman-message",
      },
      {
        label: "Secretary Message",
        url: "/pages/secretary-message",
      },
      {
        label: "Aims & Objective",
        url: "/pages/aims-and-objective",
      },
    ],
  },
  // {
  //     label: "Tutorials",
  //     submenu: [
  //         {
  //             label: "React",
  //             url: "/react",
  //             submenu: [
  //                 {
  //                     label: "Hooks",
  //                     url: "/react/hooks",
  //                 },
  //                 {
  //                     label: "Context",
  //                     url: "/react/context",
  //                     submenu: [
  //                         {
  //                             label: "Advanced Context",
  //                             url: "/react/context/advanced",
  //                             submenu: [
  //                                 {
  //                                     label: "Advanced Context 1",
  //                                     url: "/react/context/advanced-1",
  //                                 }
  //                             ]
  //                         },
  //                         {
  //                             label: "Redux",
  //                             url: "/react/context/redux",
  //                         },
  //                     ],
  //                 },
  //                 {
  //                     label: "Router",
  //                     url: "/react/router",
  //                     submenu: [
  //                         {
  //                             label: "Nested Routes",
  //                             url: "/react/router/nested",
  //                         },],
  //                 },],
  //         },
  //         {
  //             label: "JavaScript",
  //             url: "/javascript",
  //         },
  //     ],
  // },
  {
    label: "Department",
    submenu: [
      {
        label: "Secondary",
        url: "/department/secondary",
      },
      {
        label: "Senior Secondary",
        url: "/department/sen-secondary",
      },
      {
        label: "Vocational education",
        url: "/department/voc-edu",
      },
      {
        label: "Open Basic Education",
        url: "/department/open-bas-edu",
      },
      {
        label: "Fee Structure",
        url: "/department/fee-structure",
      },
    ],
  },
  {
    label: "Programmes",
    submenu: [
      {
        label: "Secondary",
        url: "/program/academic",
      },
      {
        label: "Vocational",
        url: "/program/vocational",
      },
      {
        label: "Administrartion",
        url: "/program/administrartion",
      },
      {
        label: "Evaluation",
        url: "/program/evaluation",
      },
      {
        label: "IT Cell",
        url: "/program/it-cell",
      },
      {
        label: "Dispatch and Distribution",
        url: "/program/dis-ditribution",
      },
    ],
  },
  {
    label: "Apply For AI",
    url: "/apply-for-ai",
  },
  {
    label: "Student Section",
    url: "/student-section",
  },
  {
    label: "Gallery",
    url: "/gallery",
  },
  {
    label: "Download",
    url: "/download",
  },
  {
    label: "Verification",
    url: "/verification",
  },
  {
    label: "Contact Us",
    url: "/contact-us",
  },
];

export const navBarData1 = [
  {
    label: "Home",
    url: "#",
    submenu: null, // No submenus
  },
  {
    label: "Multilevel",
    url: "#",
    submenu: [
      {
        label: "Gallery",
        url: "#",
        submenu: null,
      },
      {
        label: "Blog",
        url: "blog.html",
        submenu: null,
      },
      {
        label: "Submenu Right",
        url: "#",
        submenu: [
          {
            label: "Second Level 1",
            url: "",
            submenu: null,
          },
          {
            label: "Second Level 2",
            url: "",
            submenu: null,
          },
          {
            label: "Second Level 3",
            url: "",
            submenu: [
              {
                label: "Third Level 1",
                url: "",
                submenu: null,
              },
              {
                label: "Third Level 2",
                url: "",
                submenu: null,
              },
              {
                label: "Still don't have enough? Go much deeper!",
                url: "#",
                submenu: [
                  {
                    label: "Deep Level 1",
                    url: "",
                    submenu: null,
                  },
                  {
                    label: "Deep Level 2",
                    url: "",
                    submenu: null,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    label: "Link",
    url: "#",
    submenu: null,
  },
];

export const sliderData = [
  {
    id: 1,
    img: banner1,
    alt: "",
    slug: "",
  },
  {
    id: 1,
    img: banner2,
    alt: "",
    slug: "",
  },
  // {
  //     id: 1,
  //     img: img1,
  //     alt: "",
  //     slug: "",
  // },
  // {
  //     id: 2,
  //     img: img2,
  //     alt: "",
  //     slug: "",
  // },
  // {
  //     id: 3,
  //     img: img3,
  //     alt: "",
  //     slug: "",
  // },
  // {
  //     id: 4,
  //     img: img4,
  //     alt: "",
  //     slug: "",
  // },
  // {
  //     id: 5,
  //     img: img5,
  //     alt: "",
  //     slug: "",
  // },
  // {
  //     id: 5,
  //     img: img6,
  //     alt: "",
  //     slug: "",
  // },
];
export const sliderOtherData = [
  {
    id: 1,
    img: linkImg1,
    alt: "",
    slug: "",
  },
  {
    id: 2,
    img: linkImg2,
    alt: "",
    slug: "",
  },
  {
    id: 3,
    img: linkImg3,
    alt: "",
    slug: "",
  },
  {
    id: 4,
    img: linkImg4,
    alt: "",
    slug: "",
  },
  {
    id: 5,
    img: linkImg6,
    alt: "",
    slug: "",
  },
  {
    id: 5,
    img: linkImg7,
    alt: "",
    slug: "",
  },
];
export const languageData = [
  {
    language: "English",
    symbol: "en",
    value: 1,
    img: eng,
  },
  {
    language: "Hindi",
    symbol: "hn",
    value: 2,
    img: hindi,
  },
];

export const whatsNew = [
  {
    id: 1,
    title: "ADVERTISEMENT FOR INVITING APPLICATION FROM NGOS/CBOS FOR SELECTION",
  },
  {
    id: 2,
    title: "Recruitment Notice and Application Form",
  },
  {
    id: 3,
    title: "EOI-Hiring of a Centralised Store",
  },
  {
    id: 4,
    title:
      "Domestic Logistics by Surface - Transportation of Biological Sample Under Cold Chain Management; 4 Wheeler and 2 Wheeler",
  },
  {
    id: 5,
    title: "Regarding Disha Cluster Recruitment",
  },
  {
    id: 6,
    title: "INVITING APPLICATIONS FROM NGOS/CBOS FOR SELECTION",
  },
  {
    id: 7,
    title: "Regarding Disha Cluster Recruitment",
  },
];

// Sample Data Tender News Announcement
export const dashboardMiddlePart = [
  {
    title: "Tender Notice",
    type: "download",
    items: [
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Tender Notice for Hiring of Office Space in Srinagar (J & K) PDF FileNewgood",
        link: "#",
        isNew: true,
      },
    ],
  },
  {
    title: "Other Important Links",
    type: "link",
    items: [
      { text: "Meeting & Events", link: "#" },
      { text: "RTI", link: "#" },
      { text: "Download Section", link: "#" },
      { text: "Court Decisions", link: "#" },
      { text: "List of AI, AVI & OBE (Study Centres)", link: "#" },
      { text: "NIOS Alumni", link: "#" },
      { text: "Audio Gallery", link: "#" },
      { text: "Proud Learners of NIOS", link: "#" },
      { text: "FAQ", link: "#" },
      { text: "Conferences & Workshop", link: "#" },
      { text: "Statistical Report", link: "#" },
      { text: "SWAYAM", link: "#" },
      { text: "Cancellation & Refund policy", link: "#" },
      { text: "Articles / Papers / Research Projects", link: "#" },
      { text: "Provisions for Learners with Disability", link: "#" },
      { text: "CPGRAM", link: "#" },
    ],
  },
  {
    title: "Announcement",
    type: "download",
    items: [
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood",
        link: "#",
        isNew: true,
      },
      {
        text: "Public Alert regarding NIOS public examinations Oct-2024 of Secondary & Sr. Secondary PDF File Newgood Sr. Secondary PDF File Newgood ",
        link: "#",
        isNew: true,
      },
    ],
  },
];

// Sammple data for About section Boxes
export const newsAndEventData = {
  title: "News and Events",
  type: "download",
  items: [
    {
      text: "Dear Students, Result of Secondary (10th) & Sr. Secondary (12th) examination held in the month of April, 24 will be announced today. Concerned students are requested to check on official website (www.upsosb.ac.in) Thanks & Regards Team UPSOSB",
      link: "#",
      isNew: true,
    },
    {
      text: "Largest education system in Uttar Pradesh",
      link: "#",
      isNew: true,
    },
    {
      text: "Dear Students, Result of Secondary (10th) & Sr. Secondary (12th) examination held in the month of April, 24 will be announced today. Concerned students are requested to check on official website (www.upsosb.ac.in) Thanks & Regards Team UPSOSB",
      link: "#",
      isNew: true,
    },
    {
      text: "Largest education system in Uttar Pradesh",
      link: "#",
      isNew: true,
    },
  ],
};

export const contentData = {
  welcomeText: {
    title: "Welcome To",
    subHeading: " Uttar Pradesh State Open School Board",
    description:
      "The Uttar Pradesh State Open School Board (UPSOSB) is an autonomous board running under the auspices of Open Schooling of Uttar Pradesh Government's Education Department...The Uttar Pradesh State Open School Board (UPSOSB) is an autonomous board running under the auspices of Open Schooling of Uttar Pradesh Government's Education Department...The Uttar Pradesh State Open School Board (UPSOSB) is an autonomous board running under the auspices of Open.",
    readMoreLink: "#",
  },
  dignitaries: [
    {
      name: "Shri Yogi Adityanath",
      position: "Honorable Chief Minister",
      imgSrc: img1Abt,
    },
    {
      name: "Shri Deepak Kumar",
      position: "I.A.S Principal Secretary, Secondary Education",
      imgSrc: img4Abt,
    },
    {
      name: "Smt. Raghav Devi",
      position: "Honorable State Minister",
      imgSrc: img2Abt,
    },
    {
      name: "Smt. Ketan Sharma",
      position: "I.A.S Director General, School Education",
      imgSrc: img3Abt,
    },
    {
      name: "Dr. Mahendra Dev Pandey",
      position: "Director, Board of Secondary Education",
      imgSrc: img5Abt,
    },
  ],
};

export const AboutContentData = [
  {
    title: "Mission & Vision",
    content:
      "We help our clients to build their best possible economic We understand you’re saving for all different life events: retirement, a house, simply to build wealth, or all of the above. Your investment account should adjust to your life — not the other way around.",
  },
  {
    // title: "History",
    content:
      "Thomas Edison may have been behind the invention of the electric light bulb, but he did not work alone. Edison worked alongside partners, both financial and commercial, to get his inventions off the ground. It was installed globally, an annual market growth of 22 percent. It is continuing its progress towards becoming a mainstream competitive salary and economy reports by mine.",
  },
  {
    // title: "Principles",
    listItems: [
      "A three-party relationship – the responsible party who prepares the information to be assured; the independent practitioner who assures the information.",
      "Agreed subject matter – in the case of an audit, this would be the annual accounts of a company. However, it could be almost anything in practice – the systems operated by a state lottery, a company’s greenhouse gas emissions, controls over a supply chain, etc.",
      "Systems operated by a state lottery, a company’s greenhouse gas emissions, controls.",
    ],
  },
  {
    title: "Electrical Services With Safety In Mind",
    content:
      "To help customers block out even more of the sun, consider offering window-tinting services. Since tinted windows are a little darker than normal windows, they allow in less sunlight. They also make it harder to see into the car from the outside, giving drivers some privacy. Keep in mind that some areas have laws against - how dark tinted windows farm routine wise all yield works done by meter peals.",
  },
  {
    // title: "Motivational Points",
    listItems: [
      "Use a past defeat as a motivator. Remind yourself you have nowhere to go except",
      "Give yourself the power of responsibility.",
      "Remind yourself the only thing stopping you is yourself.",
      "Goal and remind yourself that intentions don’t count, only actions.",
    ],
  },
];

// # Extracted text from the image
// text_data = {
//     "Mission & Vision": "We help our clients to build their best possible economic We understand you’re saving for all different life events: retirement, a house, simply to build wealth, or all of the above. Your investment account should adjust to your life — not the other way around.",
//     "History": "Thomas Edison may have been behind the invention of the electric light bulb, but he did not work alone. Edison worked alongside partners, both financial and commercial, to get his inventions off the ground. It was installed globally, an annual market growth of 22 percent. It is continuing its progress towards becoming a mainstream competitive salary and economy reports by mine.",
//     "Principles": [
//         "A three-party relationship – the responsible party who prepares the information to be assured; the independent practitioner who assures the information.",
//         "Agreed subject matter – in the case of an audit, this would be the annual accounts of a company. However it could be almost anything in practice – the systems operated by a state lottery, a company’s greenhouse gas emissions, controls over a supply chain etc.",
//         "Systems operated by a state lottery, a company’s greenhouse gas emissions, controls."
//     ],
//     "Electrical Services With Safety In Mind": "To help customers block out even more of the sun, consider offering window-tinting services. Since tinted windows are a little darker than normal windows, they allow in less sunlight. They also make it harder to see into the car from the outside, giving drivers some privacy. Keep in mind that some areas have laws against - how dark tinted windows farm routine wise all yield works done ny meter peals.",
//     "Motivational Points": [
//         "Use a past defeat as a motivator. Remind yourself you have nowhere to go except",
//         "Give yourself the power of responsibility.",
//         "Remind yourself the only thing stopping you is yourself.",
//         "Goal and remind yourself that intentions don’t count, only actions."
//     ]
// }

export const accordionData = [
  {
    title: "Eco-Friendly equipments and materials",
    content:
      "One of the most common additions people make to their cars in order to keep the heat out is a windshield visor. Cars become warm in the summer because direct sunlight enters in through the windows. This is why we park in the shade whenever we can. Since the largest windshield. In fact, wind is becoming cheap enough in many places in the U.S. and around the world to compete effectively with fossil fuels.",
  },
  {
    title: "Eco-Friendly equipments and materials",
    content: "Details about additional eco-friendly materials and their impact on sustainability.",
  },
  {
    title: "Award winning design management",
    content: "Information about award-winning design practices and their benefits in project management.",
  },
];

export const sidebarData = [
  {
    url: "/Welcome/testingCenter",
    title: "Testing Centers",
    label: "Testing Centers",
  },
  { url: "/Welcome/bloodBank", title: "Blood Banks", label: "Blood Banks" },
  {
    url: "/Welcome/surakshaClinics",
    title: "Suraksha Clinics",
    label: "Suraksha Clinics",
  },
  { url: "/Welcome/artCenters", title: "ART Centers", label: "ART Centers" },
  {
    url: "https://sims.naco.gov.in/simshome/",
    title: "UPSACS MIS",
    label: "UPSACS MIS",
    isExternal: true,
  },
  {
    url: "/Welcome/linkfiles?catid=home%20%20%C2%BB%20%20guidelines",
    title: "Guidelines",
    label: "Guidelines",
  },
  { url: "/Welcome/archives", title: "Archives", label: "Archives" },
];

export const monthList = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export const contentTypeList = [
  { value: "E-Book", label: "E-Book" },
  { value: "Video", label: "Video" },
];

export const roles = [
  { value: "IT Admin", label: "IT Admin" },
  { value: "State", label: "State Admin" },
  { value: "District", label: "District Admin" },
  // { value: "Division", label: "Division Admin" },
  { value: "Subject Specialist", label: "Subject Specialist" },
  { value: "JD", label: "JD" },
  { value: "DIOS", label: "DIOS" },
];

export const questionsList = [
  {
    options: [
      {
        option: "asf",
        isCorrect: true,
      },
      {
        option: "asfaf",
        isCorrect: false,
      },
    ],

    question: "Question one",
  },
  {
    options: [
      {
        option: "aaaaaaa",
        isCorrect: false,
      },
      {
        option: "qqqqq",
        isCorrect: true,
      },
    ],

    question: "Question Two",
  },
  {
    options: [
      {
        option: "asdasdasd",
        isCorrect: true,
      },
      {
        option: "asfasssssssf",
        isCorrect: false,
      },
    ],

    question: "Question Three",
  },
  {
    options: [
      {
        option: "asdasdasd",
        isCorrect: false,
      },
      {
        option: "asfasssssssf",
        isCorrect: true,
      },
    ],

    question: "Question Four",
  },
  {
    options: [
      {
        option: "asdasdasd",
        isCorrect: false,
      },
      {
        option: "asfasssssssf",
        isCorrect: false,
      },
      {
        option: "asdasdasd",
        isCorrect: true,
      },
      {
        option: "asfasssssssf",
        isCorrect: false,
      },
    ],

    question: "Question Fice",
  },
];

export const textQ = [
  {
    question: "Hamid's favourite colour?",
    option_1: "Black",
    option_2: "Blue",
    correct: "Black ",
  },
  {
    question: "Hamid's favourite colour?",
    option_1: "Black",
    option_2: "Blue",
    correct: "Blue",
  },
  {
    question: "Hamid's favourite colour?",
    option_1: "Red",
    option_2: "Blue",
    correct: "Red",
  },
];

export const optionList =[
  {
    value:"option_0",
    label:"Option One"
  },
  {
    value:"option_1",
    label:"Option Two"
  },
  {
    value:"option_2",
    label:"Option Three"
  },
  {
    value:"option_3",
    label:"Option Four"
  },
  {
    value:"option_4",
    label:"Option Five"
  },
  {
    value:"option_5",
    label:"Option Six"
  },
  {
    value:"option_6",
    label:"Option Seven"
  },
]
